const AboutMe = ({data}) => {
    let description = data?.acf?.description || "";
    return (
        <div className="component" id="about-me">
            <div className="container">
                <div className="content-area">
                    <p>{description}</p>
                </div>
            </div>
        </div>
    );
}

export default AboutMe;